import { ExchangeRateService } from './exchange-rate-service';
import { queryClient } from '../query-client';
export const exchangeRateService = new ExchangeRateService({
    resource: 'exchange-rate',
    parentResources: [],
    middleware: [],
    queryClient,
});
